export enum UserTypeEnum {
  InternalUser = 'internal',
  ExternalUser = 'external'
}
